import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './two-line-info.module.css';

type Props = {
    header: string;
    body: string | React.ReactNode;
};

export function TwoLineInfo(props: Props) {
    return (
        <div className={styles.container}>
            <Stack spacing={4}>
                <Body size='small' isBold={true}>
                    {props.header}
                </Body>
                {typeof props.body === 'string' ? (
                    <Body truncate={{type: 'inline'}}>{props.body}</Body>
                ) : (
                    props.body
                )}
            </Stack>
        </div>
    );
}
